import React, { useEffect, useRef, useState } from "react";
import imageCompression from "browser-image-compression";
import dayjs from "dayjs";

// Image
import { Button, Modal, Progress } from "antd";
import svg from "../../Assets/svg";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik } from "formik";
import { FormikInput, FormikTextArea } from "../Input";
import {
  API_URL,
  BtnLoader,
  QUOTE_SAMPLE_CSV,
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/utils";
import { quoteValidationSchema } from "../../helpers/schema/quoteSchema";
import { AddQuoteAPI, EditQuoteAPI } from "../../Admin/Redux/quote";
import axios from "axios";
import Dragger from "antd/es/upload/Dragger";
import { RadioButtonSelectAnyOne, RenderTable } from "../Components";
import { userDurationSchema } from "../../helpers/schema/userSchema";
import { EditUserTrialDurationAPI } from "../../Admin/Redux/user";
// Close Icon Image
const CloseIcon = () => <span>{svg?.closeIcon}</span>;

var utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

/** Function to compress image before API call */
export const imageCompressorFn = async (file, setState) => {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  try {
    const compFile = await imageCompression(file, options);
    setState(compFile);
  } catch (error) {
    setState(file);
  }
};

export const DeleteModal = ({
  isOpen,
  title,
  description,
  buttonText,
  deleteHandler,
  cancelSuperHandler,
  bodyData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Modal
      open={isOpen}
      onCancel={cancelSuperHandler}
      maskClosable={false}
      closable={true}
      centered={true}
      closeIcon={<CloseIcon />}
      width={"27.5rem"}
      footer={null}
      className="modelMaxHeight"
    >
      <div className="d-flex flex-column justify-content-center mt-4 mx-4">
        <span className="align-self-center">{svg?.delete}</span>
        <h3 className="text-center mt-3 mb-3 ff ff_bd f24 mb-1 title-color">
          {title}
        </h3>
        <p className="text-center ff f16 title-color">{description}</p>
        {bodyData && bodyData}
        <button
          className={
            "btn btn-danger w143 align-self-center mb-3 border-25 cursor-pointer"
          }
          onClick={() => {
            setIsLoading(true);
            deleteHandler();
            setTimeout(() => {
              setIsLoading(false);
            }, 1500);
          }}
        >
          <p className="text-center ff ff_bd f16 py-2 text-white mb-0">
            {isLoading ? <BtnLoader /> : buttonText}
          </p>
        </button>
      </div>
    </Modal>
  );
};

export const ActionModal = ({
  isOpen,
  title,
  description,
  buttonText = "Confirm",
  isLoading = false,
  actionHandler,
  cancelHandler,
  bodyData,
  icon = svg?.delete, // Optional icon
  buttonClass = "btn btn-danger", // Default red button
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={cancelHandler}
      maskClosable={false}
      closable={true}
      centered={true}
      closeIcon={<CloseIcon />}
      width={"27.5rem"}
      footer={null}
      className="modelMaxHeight"
    >
      <div className="d-flex flex-column justify-content-center mt-4 mx-4">
        {icon && <span className="align-self-center">{icon}</span>}

        <h3 className="text-center mt-3 mb-3 ff ff_bd f24 mb-1 title-color">
          {title}
        </h3>

        <p className="text-center ff f16 title-color">{description}</p>

        {bodyData && bodyData}

        <button
          className={`${buttonClass} w143 align-self-center mb-3 border-25 cursor-pointer`}
          onClick={actionHandler}
          disabled={isLoading}
        >
          <p className="text-center ff ff_bd f16 py-2 text-white mb-0">
            {isLoading ? <BtnLoader /> : buttonText}
          </p>
        </button>
      </div>
    </Modal>
  );
};

export const EditQuoteModal = ({
  isOpen,
  title,
  description,
  buttonText,
  editHandler,
  cancelSuperHandler,
  updateData,
  modalPurpose,
  params,
  editParams,
}) => {
  // Dispatch
  const dispatch = useDispatch();

  const { quoteLoading } = useSelector((state) => state.loading);

  const [isLoading, setIsLoading] = useState(false);
  const formikRef = useRef();

  return (
    <Modal
      open={isOpen}
      onCancel={cancelSuperHandler}
      maskClosable={false}
      closable={true}
      centered={true}
      closeIcon={<CloseIcon />}
      // width={"27.5rem"}
      footer={null}
      className="modelMaxHeight"
      style={{ borderRadius: 0, overflowX: "hidden" }}
    >
      <Formik
        innerRef={formikRef}
        initialValues={{
          quote: updateData?.quote || "",
          author: updateData?.author || "",
        }}
        validationSchema={quoteValidationSchema}
        onSubmit={(values) => {
          const formData = new FormData();
          if (modalPurpose === 1) {
            formData.append("id", updateData?._id);
          }
          formData.append("quote", values?.quote);
          formData.append("author", values?.author);

          if (modalPurpose === 1) {
            dispatch(
              EditQuoteAPI(
                formData,
                cancelSuperHandler,
                params,
                editParams,
                setIsLoading
              )
            );
          } else {
            dispatch(AddQuoteAPI(formData, cancelSuperHandler, params));
          }
        }}
      >
        {({ errors, touched }) => (
          <Form className="page-form" style={{ borderRadius: 0 }}>
            <div className="">
              <FormikTextArea
                label={"Quote"}
                type={"text"}
                value={"quote"}
                placeholder={`Please Enter Quote`}
                error={touched.quote && errors.quote && errors.quote}
                className={"mb-3"}
              />

              <FormikInput
                label={"Author Name"}
                type={"text"}
                value={"author"}
                placeholder={`Please Enter Author Name`}
                error={touched.author && errors.author && errors.author}
                // className={"col-sm-7"}
              />

              <div className="text-center mt-3">
                <button
                  type="submit"
                  className="btn btn-success btn-lg theme-btn px-4"
                  disabled={quoteLoading}
                >
                  {quoteLoading && <BtnLoader />}
                  Save
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

// Bulk Import Quote
export const BulkImportQuote = ({
  modalOpen,
  modalPurpose,
  cancelHandler,
  params,
}) => {
  // Translation

  // Use Dispatch
  const dispatch = useDispatch();

  const { bulkBondsmanLoading } = useSelector((state) => state.loading);

  const [error, setError] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [alreadyExist, setAlreadyExist] = useState([]);
  const [invalidData, setInvalidData] = useState([]);
  const [insertData, setInsertData] = useState([]);

  const [onUploadStart, setOnUploadStart] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);

  const [csvType, setCSVType] = useState("alreadyExist");

  useEffect(() => {
    if (modalPurpose === 0) {
      setAlreadyExist([]);
      setInvalidData([]);
      setError(false);
    }
  }, [modalOpen, modalPurpose]);

  function onFileChange(info) {
    const { status } = info?.file;
    if (status === "removed") {
      setUploadFile(null);
    }
  }

  const props = {
    accept: "text/csv",
    progress: {
      strokeColor: {
        "0%": "#108ee9",
        "100%": "#87d068",
      },
      strokeWidth: 3,
      format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
    },
  };

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      const USER_URL = `${API_URL}/quote`;
      setOnUploadStart("Start");
      // dispatchLoading(dispatch, "bulkBondsman", true);
      dispatchLoading(dispatch, "quoteBulk", false);
      const formData = new FormData();
      formData.append("file", file);
      axios
        .post(
          `${USER_URL}/bulk`,
          formData
          // {
          // 	withCredentials: true,
          // 	onUploadProgress: (progressEvent) => {
          // 		const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          // 		setUploadProgress(percentCompleted);
          // 	},
          // }
        )
        .then((result) => {
          if (result?.data?.success) {
            dispatchToast(dispatch, "success", result?.data?.message);
            dispatchError(dispatch, "quoteBulk", undefined);
            onSuccess();
            setError(false);
            setUploadFile(file);
            setOnUploadStart("Stop");
            setAlreadyExist(result?.data?.data?.alreadyExist);
            setInvalidData(result?.data?.data?.invalidData);
            setInsertData(result?.data?.data?.insertData);
            if (result?.data?.data?.alreadyExist?.length > 0) {
              setCSVType("alreadyExist");
            }
            if (result?.data?.data?.invalidData?.length > 0) {
              setCSVType("invalidData");
            }
            if (result?.data?.data?.insertData?.length > 0) {
              setCSVType("insertData");
            }

            params && params();
          } else {
            setOnUploadStart("Stop");
            setError(false);
            elseHandler(dispatch, "quoteBulk", result?.data);
            onError();
          }
        })
        .catch(catchHandler(dispatch, "quoteBulk"));
      dispatchLoading(dispatch, "quoteBulk", false);
    } catch (err) {
      elseHandler(dispatch, "quoteBulk", false);
    }
  };

  const CSVOption = [
    {
      name: "Already Exist",
      value: "alreadyExist",
      length: alreadyExist?.length,
    },
    {
      name: "Invalid Data",
      value: "invalidData",
      length: invalidData?.length,
    },
    {
      name: "Inserted Data",
      value: "insertData",
      length: insertData?.length,
    },
  ];

  const stateDataMap = {
    alreadyExist: {
      data: alreadyExist,
      error: "Uploaded data with following records already exists",
    },
    invalidData: {
      data: invalidData,
      error: "Uploaded data with following records are invalid",
    },
    insertData: {
      data: insertData,
      error: "Uploaded data with following records inserted successfully",
    },
  };

  const stateData = csvType ? stateDataMap[csvType] || null : null;

  const zero =
    alreadyExist?.length === 0 &&
    invalidData?.length === 0 &&
    insertData?.length === 0;
  const downloadSampleCSV = () => {
    // window.open(QUOTE_SAMPLE_CSV, "_blank");

    // Create a temporary anchor element
    const tempAnchor = document.createElement("a");

    // Set the href attribute to the URL of the sample CSV file
    tempAnchor.href = QUOTE_SAMPLE_CSV;

    // Set the download attribute to specify the filename of the downloaded file
    tempAnchor.download = "sample.csv";

    // Programmatically click the anchor element to trigger the download
    tempAnchor.click();

    // Clean up by removing the temporary anchor element
    tempAnchor.remove();
  };

  return (
    <Modal
      open={modalOpen}
      onOk={cancelHandler}
      onCancel={cancelHandler}
      footer={[]}
      className="antdModal BulkImportBondsMan"
      maskClosable={false}
      closable={true}
      centered={true}
      closeIcon={<CloseIcon />}
      width={uploadFile && !zero ? 1024 : 576}
    >
      <div>
        <h3 className="antdModalTitle my-3">{"Bulk Import Quotes"}</h3>

        <div>
          <div className="d-flex justify-content-end">
            {/* Download Sample CSV button
						<Button type="primary" onClick={downloadSampleCSV}>
							Download Sample CSV
						</Button> */}
          </div>

          <label className="form-label fw-semibold fs-6 text-black d-flex justify-content-between">
            <span>{"Choose File"} </span>
            <button
              className="btn btn-transparent fw-bold fs-6 p-0 txt-primary"
              onClick={downloadSampleCSV}
            >
              Download Sample CSV
            </button>
          </label>

          <Dragger
            {...props}
            listType="picture"
            maxCount={1}
            className={`antdUpload antdDragger docUpload ${
              uploadFile && "d-none"
            }`}
            withCredentials
            onChange={onFileChange}
            customRequest={customRequest}
          >
            <>
              {onUploadStart === "Start" ? (
                <Progress percent={uploadProgress} />
              ) : (
                <div className="">
                  <div>{svg?.fileUpload}</div>
                  <p className="mt-2">
                    {"Drag & Drop File"} /{" "}
                    <span className="txt-error">
                      {"Click Here To Upload File"}
                    </span>
                  </p>
                  <p className="mt-0">{"You can upload file etc..."}</p>
                </div>
              )}
            </>
          </Dragger>

          {uploadFile && (
            <>
              <div className="antdDragger uploadPreviewBorder p-3 text-center justify-content-center position-relative">
                <div
                  className="onRemove cursor-pointer d-flex"
                  onClick={() => setUploadFile(null)}
                >
                  {svg?.onRemoveDocument}
                </div>
                <div className="h-100">
                  <div className="uploadedFileSuccess">
                    {svg?.uploadedFileSuccess}
                  </div>
                  <p className="txt-error mt-1 fw-bolder text-capitalize f24">
                    {uploadFile?.name}
                  </p>
                </div>
              </div>
            </>
          )}

          <small className="text-danger d-block text-start">
            {error && "Please upload the csv file"}
            {"  "}&nbsp;
          </small>
        </div>

        {uploadFile && !zero && (
          <>
            <div className="d-flex gap-2 mt-1">
              <RadioButtonSelectAnyOne
                data={CSVOption}
                value={csvType}
                setValue={setCSVType}
                name={"csv-type"}
                className={`min-fit-content h46`}
              />
            </div>
            <RenderTable data={stateData?.data} title={stateData?.error} />
          </>
        )}

        <div className="text-center mt-3">
          <button
            className="btn btn-lg c-success text-uppercase fw-semibold fs-6 px-2 px-md-4 text-white "
            onClick={cancelHandler}
            disabled={bulkBondsmanLoading}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export const EditFreeSubPeriodModel = ({
  isOpen,
  title,
  description,
  buttonText,
  editHandler,
  cancelSuperHandler,
  updateData,
  modalPurpose,
  fetchData,
  editParams,
}) => {
  // Dispatch
  const dispatch = useDispatch();

  const { quoteLoading } = useSelector((state) => state.loading);

  const [isLoading, setIsLoading] = useState(false);
  const formikRef = useRef();
  console.log("updateData", updateData);
  let subscriptionData = updateData?.user_current_subscription?.[0];
  return (
    <Modal
      open={isOpen}
      onCancel={cancelSuperHandler}
      maskClosable={false}
      closable={true}
      centered={true}
      closeIcon={<CloseIcon />}
      // width={"27.5rem"}
      footer={null}
      className="modelMaxHeight"
      style={{ borderRadius: 0, overflowX: "hidden" }}
    >
      <Formik
        innerRef={formikRef}
        initialValues={{
          durations: subscriptionData?.durations || "",
          id: updateData?._id,
        }}
        validationSchema={userDurationSchema(subscriptionData?.durations || 0)}
        onSubmit={(values) => {
          console.log("values", values);
          const formData = new FormData();
          if (modalPurpose === 1) {
            formData.append("id", updateData?._id);
          }
          formData.append("days", values?.durations);

          if (modalPurpose === 1) {
            setIsLoading(true);

            dispatch(
              EditUserTrialDurationAPI(
                formData,
                cancelSuperHandler,
                editParams,
                setIsLoading
              )
            );
          }
        }}
      >
        {({ errors, touched }) => (
          <Form className="page-form" style={{ borderRadius: 0 }}>
            <div className="row gy-1">
              <FormikInput
                label={"Enter Free Trial Duration (In Days)"}
                type={"number"}
                value={"durations"}
                placeholder={`Enter Free Trial Duration (In Days)`}
                error={
                  touched.durations && errors.durations && errors.durations
                }
                // className={"custom-input"}
              />

              <div className="text-center mt-3">
                {isLoading ? (
                  <BtnLoader />
                ) : (
                  <button
                    type="submit"
                    className="btn btn-success btn-lg theme-btn px-4"
                    disabled={isLoading}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
